/**
 * Collapse a trailing slash so `/x` and `/x/` resolve to one backend lookup and one
 * `useFetch` key. Without this, the slash-insensitive SWR cache serves `/x`'s render
 * for `/x/`, then hydration re-fetches the literal `/x/` (a CMS NOTFOUND) and rips the
 * content out, leaving only the layout. Root `/` is preserved; `route.path` (the
 * canonical/SEO signal) is left untouched.
 */
export function normalizeContentUrl(url: string): string {
  return url.length > 1 && url.endsWith('/') ? url.slice(0, -1) : url
}
